import AdminDashboard from '@/views/tableau-de-bord/dashboard-admin';
import InfirmierDashboard from '@/views/tableau-de-bord/dashboard-infirmier';
import MedecinDashboard from '@/views/tableau-de-bord/dashboard-medecin';
import LaboratinDashboard from '@/views/tableau-de-bord/dashboard-laboratin';
import MdtDashboard from '@/views/tableau-de-bord/dashboard-mdt';
import SageFemmeDashboard from '@/views/tableau-de-bord/dashboard-sage-femme';

export default {
    name: 'tableau-de-bord',
    components: {
        AdminDashboard,
        InfirmierDashboard,
        MedecinDashboard,
        LaboratinDashboard,
        MdtDashboard,
        SageFemmeDashboard
    },
    props: [],
    data() {
        return {
            user_role: '',
            active_role: '',
        }
    },
    
    computed: {
        /**
         * User Info
         * @returns 
         */
        userCredentials() {
            return this.$store.getters['authInfo'];
        },

        activeRole() {
            return this.$store.getters['activeRole'];
        },
    },

    mounted() {
        if (this.userCredentials.roles.length > 0) {
            this.user_role = this.userCredentials.roles[0].nom;
        }

        if (this.activeRole.nom == 'ROLE_TECHNICIEN_IMAGERIE' || this.activeRole.nom == 'ROLE_RADIOLOGUE') {
            this.$router.push({ path: '/examens/porter-resultat' });
        }

        this.active_role = this.activeRole.nom
    },

    methods: {

    }
}